import AxiosService from '../AxiosService';
import SharedStatusService from '../shared/SharedStatusService';

const STATUS_ADMIN_ENDPOINT = "/api/v1/admin/status"

export default class StatusService {

  constructor() {
    this.service = new AxiosService();
    this.statusService = new SharedStatusService();
  }

  resolveLabel(status) {
    let found = this.statusService.resolveAllStatuses().filter(e => e.key === status);
    if (found.length === 0) {
      return 'onbekend';
    }
    return found[0].label;
  }

  allStatuses(uniqueIdAddress) {
    return this.service.get(`/api/v1/admin/addresses/${uniqueIdAddress}/status`);
  }

  updateStatus(uniqueIdAssignment, uniqueIdAddress, status) {
    let payload = {
      'uniqueIdAssignment': uniqueIdAssignment,
      'uniqueIdAddress': uniqueIdAddress,
      'status': status
    };
    return this.service.post(STATUS_ADMIN_ENDPOINT, payload, null)
  }

  resolveStatus(uniqueIdAddress) {
    return this.service.get(`/api/v1/addresses/${uniqueIdAddress}/status`);
  }

}
